import { render, staticRenderFns } from "./featured-intro-section.vue?vue&type=template&id=05dea03e"
import script from "./featured-intro-section.vue?vue&type=script&lang=js"
export * from "./featured-intro-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports